import { ZapIcon } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
const CHECKOUT_URL = 'https://soldadura.impultienda.ar/checkout/soldadura';

/**
 * Primary call-to-action. Big, amber, full-width on mobile. Fires the pixel
 * InitiateCheckout event and links to the checkout.
 */
export function CtaButton({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} className={`pulse-glow group relative flex w-full items-center justify-center gap-2.5 rounded-xl bg-amber-500 px-5 py-4 text-center font-cond text-lg font-bold uppercase tracking-wide text-[#0d0d0f] shadow-lg shadow-amber-500/30 transition-transform duration-150 hover:bg-amber-400 active:scale-[0.98] sm:text-xl ${className}`} data-id="element-180" data-mp="qjiitoebmu0g">
      <ZapIcon className="h-5 w-5 shrink-0 fill-[#0d0d0f]" data-id="element-181" data-mp="19bl3dau32ufz" />
      <span className="leading-tight" data-id="element-182" data-mp="159zue0ko70b2">{children}</span>
    </a>;
}